import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  vat_payable_account: yup
    .string()
    .required("VAT payable account mapping is required"),
  vat_receivable_account: yup
    .string()
    .required("Account payable account mapping is required"),
});

const Validation = ({ taxesAccountMapping }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      ...taxesAccountMapping,
    },
  });
};

export default Validation;
